<template>
  <div>
    <!-- Book list -->
    <div>
      <vs-table id="book-list" class="vs-con-loading__container" stripe :sst="true" maxHeight="800px"
        @search="updateSearchQuery" @change-page="handleChangePage" @sort="handleSort" :total="FilteredCount"
        :max-items="length" search :data="records">
        <template slot="header">
          <div class="mb-2 flex items-center">
            <div class="flex flex-wrap justify-between items-center">
              <div class="mb-4 md:mb-0 mr-4 ag-grid-table-actions-left">
                <vs-dropdown vs-trigger-click class="cursor-pointer filter-font">
                  <div
                    class="p-4 border border-solid d-theme-border-grey-light rounded-lg d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                    <span class="mr-2">
                      {{ page * length - (length - (FilteredCount && 1)) || 0 }}
                      -
                      {{ FilteredCount - page * length > 0 ? page * length : FilteredCount }}
                      of {{ total || 0 }}
                    </span>
                    <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                  </div>
                  <vs-dropdown-menu>
                    <vs-dropdown-item @click="handleChangeLength(10)">
                      <span>10</span>
                    </vs-dropdown-item>
                    <vs-dropdown-item @click="handleChangeLength(20)">
                      <span>20</span>
                    </vs-dropdown-item>
                    <vs-dropdown-item @click="handleChangeLength(50)">
                      <span>50</span>
                    </vs-dropdown-item>
                    <vs-dropdown-item @click="handleChangeLength(100)">
                      <span>100</span>
                    </vs-dropdown-item>
                  </vs-dropdown-menu>
                </vs-dropdown>
              </div>
            </div>

            <div v-if="checkPermissionSlug(['book_create'])" @click="addPage"
              class="btn-add-new p-2 mr-4 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-primary border border-solid border-primary">
              <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
              <span class="ml-2 text-base text-primary">Add {{ module_name }}</span>
            </div>
            <div class="flex flex-wrap items-center">
              <!-- Custom Pagination -->
              <vs-pagination v-if="FilteredCount" v-model="page" :total="totalPages"
                :max="totalPages / length > 7 ? 7 : 5" class="mt-1"></vs-pagination>
            </div>
          </div>
        </template>

        <template slot="thead">
          <vs-th>Sr#</vs-th>
          <vs-th sort-key="Book.title">Title</vs-th>
          <vs-th v-if="checkPermissionSlug(['book_edit'])" sort-key="Book.status">Visible</vs-th>
          <vs-th sort-key="Book.section_type">Section Type</vs-th>
          <vs-th sort-key="Book.structure_type">Structure Type</vs-th>
          <vs-th sort-key="Book.structure_type">Reported Problems</vs-th>
          <vs-th sort-key="Book.positive_reviews_count">Positive Reviews Count</vs-th>
          <vs-th sort-key="Book.negative_reviews_count">Negative Reviews Count</vs-th>
          <vs-th v-if="checkPermissionSlug(['book_edit']) || checkPermissionSlug(['book_delete'])">Action</vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr :data="tr" :key="i" v-for="(tr, i) in data">
            <vs-td>
              {{ page * length - (length - i - 1) }}
            </vs-td>
            <vs-td class="text-left w-1/5">
              <span class="cursor-pointer" v-if="checkPermissionSlug(['book_edit'])"
                @click.stop="toggleEditModal(tr._id, $event)" v-tooltip="{ content: `Edit ${tr.title}` }">{{
                  tr.title || '-'
                }}</span>
              <span v-else>{{ tr.title || '-' }}</span>
            </vs-td>
            <vs-td class="text-left" v-if="checkPermissionSlug(['book_edit'])">
              <vs-switch icon-pack="feather" vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" color="primary"
                :value="tr.is_active" @click.stop="updateStatus(tr._id, !tr.is_active)">
                <span slot="on"></span>
                <span slot="off"></span>
              </vs-switch>
            </vs-td>

            <vs-td class="text-left">
              <vs-chip color="success">{{ tr.section_type || '-' }} </vs-chip>
            </vs-td>

            <vs-td class="text-left">
              <strong>{{ tr.structure_type }}</strong>
              {{ structureTypeTooltipValue(tr.structure_type) || '-' }}
            </vs-td>

            <vs-td class="text-center">
              <vx-tooltip :text="`Total Reported Problems`">
                <span class="cursor-pointer"
                  :style="{ color: tr.reported_problems_negative_count > tr.reported_problems_positive_count ? '#f87171' : '#34d399' }"
                  @click.stop="reportAProblems(tr._id, $event)">
                  {{ Number(tr.reported_problems_negative_count || 0) + Number(tr.reported_problems_positive_count || 0)
                  || 0 }}</span>
              </vx-tooltip>
            </vs-td>

            <vs-td class="text-center">
              <vx-tooltip :text="`View Positive Reviews Count`">
                <span class="cursor-pointer" @click.stop="highlightFeedback(tr._id, $event, 'positive')"> {{
                  tr.positive_reviews_count || 0 }}</span>
              </vx-tooltip>
            </vs-td>
            <vs-td class="text-center">
              <vx-tooltip :text="`View Negative Reviews Count`">
                <span class="cursor-pointer" @click.stop="highlightFeedback(tr._id, $event, 'negative')"> {{
                  tr.negative_reviews_count || 0 }}</span>
              </vx-tooltip>
            </vs-td>

            <vs-td v-if="checkPermissionSlug(['book_edit']) || checkPermissionSlug(['book_delete'])">
              <div class="inline-flex">
                <vx-tooltip v-if="tr.structure_type === 'Type 4' && checkPermissionSlug(['book_edit'])"
                  :text="`Add Pankti`">
                  <feather-icon @click.stop="addSoloBook(tr._id, $event)" icon="PlusSquareIcon"
                    svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" />
                </vx-tooltip>
                <vx-tooltip v-else-if="tr.structure_type === 'Type 1' && checkPermissionSlug(['book_edit'])"
                  :text="`Add Pauri & Slok`">
                  <feather-icon @click.stop="addPauriAndSlok(tr._id, $event)" icon="PlusSquareIcon"
                    svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" />
                </vx-tooltip>
                <vx-tooltip v-else-if="tr.structure_type === 'Type 3' && checkPermissionSlug(['book_edit'])"
                  :text="`Add Header`">
                  <feather-icon @click.stop="addHeader(tr._id, $event)" icon="PlusSquareIcon"
                    svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" />
                </vx-tooltip>
                <vx-tooltip v-else-if="tr.structure_type === 'Type 2' && checkPermissionSlug(['book_edit'])"
                  :text="`Add Ashtapadi`">
                  <feather-icon @click.stop="addAshtapadi(tr._id, $event)" icon="PlusSquareIcon"
                    svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" />
                </vx-tooltip>
                <vx-tooltip :text="`Edit ${module_name}`" v-if="checkPermissionSlug(['book_edit'])">
                  <feather-icon @click.stop="toggleEditModal(tr._id, $event)" icon="EditIcon"
                    svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" />
                </vx-tooltip>
                <vx-tooltip :text="`Delete ${module_name}`" v-if="checkPermissionSlug(['book_delete'])">
                  <feather-icon @click.stop="deleteRecord(tr._id)" icon="Trash2Icon"
                    svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" />
                </vx-tooltip>
              </div>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'

export default {
  name: 'BookList',

  /** Data */
  data: () => ({
    order: [],
    length: 100,
    page: 1,
    search: '',
    module_name: 'Book',
    active: false
  }),

  /** computed */
  computed: {
    ...mapState('book', ['records', 'total', 'FilteredCount', 'listLoading']),
    ...mapGetters('auth', ['checkPermissionSlug']),
    totalPages() {
      return Math.ceil(this.FilteredCount / this.length)
    }
  },

  /** Functions */
  methods: {
    ...mapActions('book', {
      get: 'get',
      delete: 'delete'
    }),

    /** Per Page Limit Change */
    handleChangeLength(length) {
      this.page = 1
      this.length = length
      this.getData()
    },

    /** Page Change */
    handleChangePage(page) {
      this.page = page
      this.getData()
    },

    /** Sorting Table Data */
    handleSort(key, active) {
      if (!key) return
      this.page = 1
      this.order = [key, active === 'desc' ? 'DESC' : 'ASC']
      this.getData()
    },

    /** Search Query */
    updateSearchQuery(val) {
      this.page = 1
      this.search = val
      this.getData()
    },

    /** Book List API */
    getData() {
      this.get({
        // order: this.order,
        limit: this.length,
        page: this.page,
        search: this.search,
        type: this.type
      })
    },

    // Add Book modal
    addPage() {
      this.$router.push(`/book/add`)
    },

    // Edit Book modal
    toggleEditModal(id, event) {
      const editUrl = `/book/${id}/edit`
      if (event.ctrlKey || event.metaKey) {
        // Let browser handle the default Ctrl + Click behavior
        window.open(editUrl, '_blank')
      } else {
        // Navigate in the same tab
        this.$router.push(editUrl)
      }
    },

    // add pauri and Slok modal
    addPauriAndSlok(id, event) {
      const editUrl = `/book/${id}/pauri`
      if (event.ctrlKey || event.metaKey) {
        // Let browser handle the default Ctrl + Click behavior
        window.open(editUrl, '_blank')
      } else {
        // Navigate in the same tab
        this.$router.push(editUrl)
      }
    },

    addHeader(id, event) {
      const editUrl = `/book/${id}/header`
      if (event.ctrlKey || event.metaKey) {
        // Let browser handle the default Ctrl + Click behavior
        window.open(editUrl, '_blank')
      } else {
        // Navigate in the same tab
        this.$router.push(editUrl)
      }
    },

    addAshtapadi(id, event) {
      const url = `/book/${id}/ashtapadi`
      if (event.ctrlKey || event.metaKey) {
        // Let browser handle the default Ctrl + Click behavior
        window.open(url, '_blank')
      } else {
        // Navigate in the same tab
        this.$router.push(url)
      }
    },

    // Highlight Feedback
    highlightFeedback(id, event, type) {
      const editUrl = `/book/${id}/highlight-feedback/list/${type}`
      if (event.ctrlKey || event.metaKey) {
        // Let browser handle the default Ctrl + Click behavior
        window.open(editUrl, '_blank')
      } else {
        // Navigate in the same tab
        this.$router.push(editUrl)
      }
    },

    // Report a Problems
    reportAProblems(id, event) {
      const editUrl = `/book/${id}/report-problems/list`
      if (event.ctrlKey || event.metaKey) {
        // Let browser handle the default Ctrl + Click behavior
        window.open(editUrl, '_blank')
      } else {
        // Navigate in the same tab
        this.$router.push(editUrl)
      }
    },

    // add solo-book
    addSoloBook(id, event) {
      const editUrl = `/book/${id}/solo-book/update`
      if (event.ctrlKey || event.metaKey) {
        // Let browser handle the default Ctrl + Click behavior
        window.open(editUrl, '_blank')
      } else {
        // Navigate in the same tab
        this.$router.push(editUrl)
      }
    },

    structureTypeTooltipValue(value) {
      switch (value) {
      case 'Type 1':
        return '(Slock & Pauri -> Pankti)'
      case 'Type 2':
        return '(Ashtapadi -> Slock & Pauri -> Pankti)'
      case 'Type 3':
        return '(Headers -> Slock & Pauri -> Pankti)'
      case 'Type 4':
        return '(Solo Reading -> Only Pankti)'
      default:
        return ''
      }
    },

    /** Delete Book Confirmation */
    deleteRecord(id) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'primary',
        title: `Confirm Delete`,
        text: `Are you sure you want to delete this record?`,
        accept: () => this.deleteSingleRecord(id),
        acceptText: 'Delete'
      })
    },

    /** Delete Book API */
    async deleteSingleRecord(id) {
      try {
        const { message } = await this.delete(id)
        this.$vs.notify({
          title: 'Success',
          text: message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-center',
          time: 5000,
          color: 'success'
        })
        this.getData()
      } catch ({ message }) {
        this.$vs.notify({
          title: 'Error',
          text: message,
          iconPack: 'feather',
          position: 'top-center',
          time: 5000,
          icon: 'icon-alert-circle',
          color: 'primary'
        })
      }
    },

    /** updateStatus API */
    updateStatus(id, status) {
      this.$store
        .dispatch('book/updateStatus', {
          id,
          status
        })
        .then((Success) => {
          const { message } = Success
          this.$vs.notify({
            title: 'Success',
            text: message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            position: 'top-center',
            time: 5000,
            color: 'success'
          })
          this.getData()
        })
        .catch((err) => {
          const { message } = err
          this.$vs.notify({
            title: 'Error',
            text: message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            position: 'top-center',
            time: 5000,
            color: 'primary'
          })
        })
    }
  },

  /** Watchers */
  watch: {
    listLoading() {
      if (this.listLoading) {
        this.$vs.loading({
          container: '#book-list',
          scale: 0.45
        })
      } else {
        this.$vs.loading.close('#book-list > .con-vs-loading')
      }
    },
    page() {
      this.getData()
    }
  },

  /** On Rendering */
  mounted() {
    this.getData()
  }
}
</script>
